<template>
  <div class="bg-container">
    <div class="login">
      <van-nav-bar>
        <template #left>
          <van-icon name="arrow-left" color="#3de0ff" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="logo">
        <img src="/img/login/logo2.png" alt="">
      </div>
      <div class="panel">
        <div class="wrap">
          <div class="input_wrap">
            <van-icon name="contact-o" size="18" color="#3de0ff"></van-icon>
            <input type="text" :placeholder="$t('auth.username_place')" v-model="username">
          </div>
          <div class="input_wrap">
            <van-icon name="lock" size="18" color="#3de0ff"></van-icon>
            <input :placeholder="$t('auth.pwd_place')" v-model="password" :type="pwdType == 1 ? 'password' : 'text'">
            <van-icon :name="pwdType == 0 ? 'eye-o' : 'closed-eye'" color="#8e9bb8" size="20" @click="pwdType = pwdType == 1 ? 0 : 1"></van-icon>
          </div>
          <div class="input_wrap">
            <van-icon name="invitation" size="18" color="#3de0ff"></van-icon>
            <input type="text" :placeholder="$t('auth.invite_code_place')" v-model="code">
          </div>
        </div>
        <div class="button" @click="doRegister()">{{$t("auth.register")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pwdType: 1,
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  mounted(){
    
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(res.msg);
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.login ::v-deep .van-nav-bar {
  background: transparent;
  background-image: none;
  .van-icon {
    font-size: 1.3rem;
  }
  .van-nav-bar__left {
    width: 2.3rem;
    height: 2.3rem;
    margin-left: 0.7rem;
    border-radius: 0.35rem;
    background: rgba(8, 14, 28, 0.72);
    border: 1px solid rgba(61, 224, 255, 0.4);
    box-shadow: 0 0 0.7rem rgba(61, 224, 255, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.bg-container {
  background: @bg-page;
  height: 100%;
}
.login {
  position: relative;
  // display: flex;
  // flex-direction: column;
  height: 100%;
  width: 100%;
  // padding: 3.6rem 0.9rem 1.5rem;
  background:
    radial-gradient(80% 42% at 100% 0%, rgba(255, 61, 154, 0.28), transparent 58%),
    radial-gradient(70% 40% at 0% 100%, rgba(61, 224, 255, 0.2), transparent 55%),
    linear-gradient(180deg, rgba(7, 11, 20, 0.92) 0%, rgba(7, 11, 20, 0.97) 100%),
    url('/public/img/login/bg2.png') no-repeat 50% / cover;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(180, 77, 255, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(180, 77, 255, 0.05) 1px, transparent 1px);
    background-size: 1.8rem 1.8rem;
    mask-image: linear-gradient(180deg, #000 0%, transparent 72%);
  }
}

.logo {
  position: relative;
  z-index: 1;
  width: 8.6rem;
  margin: auto auto 1.3rem;
  img{
    width: 100%;
    filter: drop-shadow(0 0 0.7rem rgba(255, 61, 154, 0.45)) drop-shadow(0 0 1.2rem rgba(61, 224, 255, 0.35));
  }
}

.panel {
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 0;
  padding: 1.25rem 1rem 1.2rem;
  border-radius: 0.55rem;
  background: rgba(10, 16, 32, 0.72);
  border: @glass-border;
  box-shadow: @shadow-soft, inset 0 1px 0 rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  &::before {
    content: '';
    position: absolute;
    left: 1.15rem;
    right: 1.15rem;
    top: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, @neon-pink, @neon-purple, @neon-blue, transparent);
    box-shadow: 0 0 0.7rem rgba(255, 61, 154, 0.55);
  }
}

.wrap{
  .input_wrap{
    width: 100%;
    height: 2.85rem;
    margin: 0 0 0.65rem;
    border-radius: 0.35rem;
    overflow: hidden;
    background: rgba(6, 10, 20, 0.72);
    border: 1px solid rgba(150, 180, 220, 0.2);
    border-left: 3px solid rgba(180, 77, 255, 0.8);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 0.9rem;
    &:focus-within {
      border-color: rgba(180, 77, 255, 0.5);
      border-left-color: @neon-blue;
      box-shadow: 0 0 0.8rem rgba(180, 77, 255, 0.2);
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      border: none;
      background: none;
      outline: none;
      text-align: left;
      font-size: 0.95rem;
      padding-left: 0.7rem;
      color: @text-title;
      &::placeholder {
        color: @text-sub;
      }
    }
  }
}

.button{
  width: 100%;
  background: @grad-primary;
  box-shadow: @shadow-pink;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.14rem;
  color: #fff;
  text-align: center;
  height: 2.85rem;
  line-height: 2.85rem;
  border-radius: 0.35rem;
  margin: 0.2rem 0 0;
}
</style>
